/**
 * 버블 계곡 (classic-bubble)
 *
 * 이 파일은 tools/derive-classic-maps.mjs 가 만든다. 손으로 고치지 말고 그 스크립트를 고쳐라.
 * 원본: lazygyu/roulette (MIT) 커밋 47230e32242e1c82030eacb4a263420fe95cedb6 의 src/data/maps.ts — "BubblePop"
 * 자세한 출처와 라이선스는 THIRD_PARTY_NOTICES.md 를 보라.
 */

import type { MapDefinition } from '../map/types.ts';

export const classicBubble: MapDefinition = {
  id: "classic-bubble",
  version: 1,
  name: "버블 계곡",
  category: 'classic',
  description: "원형 장애물을 터뜨리며 지그재그 구간과 다각형 지형을 지나고, 회전 장치가 지키는 좁은 출구로 빠져나간다.",
  highlights: ["터지는 원형 장애물","지그재그 구간","다각형 지형","회전 장치와 좁은 출구"],
  origin: {"originalTitle":"BubblePop","note":"터지는 원형 장애물과 출구 회전 장치, 좁은 결승 통로를 계승했다."},
  bounds: {"x":0,"y":-20,"w":26,"h":112},
  preview: {"x":2,"y":-8,"w":22,"h":96},
  spawn: {"area":{"x":9.7,"y":-8,"w":6.35,"h":10},"perRow":10,"gap":0.62},
  finish: { area: {"x":0,"y":83,"w":26,"h":6} },
  checkpoints: [{"id":"cp1","name":"첫 낙하","area":{"x":0,"y":20,"w":26,"h":2}},{"id":"cp2","name":"지그재그","area":{"x":0,"y":34,"w":26,"h":2}},{"id":"cp3","name":"버블 구간","area":{"x":0,"y":48,"w":26,"h":2}},{"id":"cp4","name":"다각형 지형","area":{"x":0,"y":64,"w":26,"h":2}},{"id":"cp5","name":"좁은 출구","area":{"x":0,"y":76,"w":26,"h":2}}],
  estimatedDurationSec: [14,21],
  timeLimitSec: 150,
  progressPath: [
    [12.875,-18],
    [12.875,15],
    [14.375,27],
    [13.875,49.5],
    [11.875,54],
    [12.875,57],
    [12.875,71],
    [12.875,71.255],
    [12.875,71.5],
    [12.875,75],
    [12.5,80],
    [12.5,83],
    [12.5,85],
  ],
  obstacles: [
    {"t":"wall","points":[[16.5,-20],[9.25,-20],[9.25,0],[9.25,43],[4.25,50],[9.25,53],[9.25,71],[9.462,71.25],[9.25,71.5],[9.25,75],[12,80],[12,83]],"style":"wall"},
    {"t":"wall","points":[[16.5,-20],[16.5,50],[19.5,54],[18.5,56],[19.5,58],[16.5,61],[16.5,71],[16.288,71.259],[16.5,71.5],[16.5,75],[13,80],[13,83]],"style":"wall"},
    {"t":"wall","points":[[16.5,52.5],[17.5,54],[16.5,56],[17.5,58],[16.5,59],[15.5,56],[16.5,52.5]],"style":"wall"},
    {"t":"wall","points":[[9.25,45.5],[6.25,49.5],[9.25,51],[14.5,50.5],[9.25,45.5]],"style":"wall"},
    {"t":"wall","points":[[9.25,26],[11.063,27.5]],"style":"wall"},
    {"t":"wall","points":[[16.5,26],[14.688,27.5]],"style":"wall"},
    {"t":"wall","points":[[11.063,30],[12.875,28.5],[14.688,30]],"style":"wall"},
    {"t":"wall","points":[[9.25,31],[11.063,32.5]],"style":"wall"},
    {"t":"wall","points":[[16.5,31],[14.688,32.5]],"style":"wall"},
    {"t":"wall","points":[[11.063,35],[12.875,33.5],[14.688,35]],"style":"wall"},
    {"t":"box","x":9.25,"y":18,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":11.25,"y":18,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":13.25,"y":18,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":15.25,"y":18,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":10.5,"y":19,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":19,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":14.5,"y":19,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16.5,"y":19,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":9.25,"y":20,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":11.25,"y":20,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":13.25,"y":20,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":15.25,"y":20,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":10.5,"y":21,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":21,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":14.5,"y":21,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16.5,"y":21,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":9.25,"y":22,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":11.25,"y":22,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":13.25,"y":22,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":15.25,"y":22,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":10.5,"y":23,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":12.5,"y":23,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":14.5,"y":23,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16.5,"y":23,"hw":0.15,"hh":0.15,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":9.4,"y":39,"hw":3,"hh":3,"angle":0.785,"style":"box","restitution":0},
    {"t":"box","x":16.5,"y":43,"hw":3,"hh":3,"angle":0.785,"style":"box","restitution":0},
    {"t":"circle","x":11,"y":65,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":65,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15,"y":65,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12,"y":67.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14,"y":67.5,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13,"y":69.771,"r":0.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":10.7,"y":77.5,"r":0.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":14.7,"y":77.5,"r":0.8,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.625,"y":80,"r":1.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":12.625,"y":80,"r":1.2,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":9.948,"y":62.596,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":11.948,"y":62.596,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":13.948,"y":62.596,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
    {"t":"circle","x":15.828,"y":62.596,"r":0.5,"pop":true,"style":"bubble","restitution":1.5},
  ],
  devices: [
    {"t":"spinner","x":10.7,"y":10,"hw":0.5,"hh":0.1,"omega":10,"angle":0,"style":"spinner"},
    {"t":"spinner","x":14.7,"y":10,"hw":0.5,"hh":0.1,"omega":-10,"angle":0,"style":"spinner"},
    {"t":"spinner","x":12.7,"y":10,"hw":0.5,"hh":0.1,"omega":10,"angle":0,"style":"spinner"},
    {"t":"spinner","x":10.7,"y":14,"hw":2,"hh":0.1,"omega":-3,"angle":0,"style":"spinner"},
    {"t":"spinner","x":14.7,"y":14,"hw":2,"hh":0.1,"omega":3,"angle":0,"style":"spinner"},
    {"t":"spinner","x":11.2,"y":44,"hw":0.5,"hh":0.1,"omega":-5,"angle":0,"style":"spinner"},
    {"t":"spinner","x":10.3,"y":75,"hw":1,"hh":0.1,"omega":8,"angle":0,"style":"spinner"},
    {"t":"spinner","x":15.462,"y":75,"hw":1,"hh":0.1,"omega":-8,"angle":0,"style":"spinner"},
    {"t":"spinner","x":12.625,"y":56,"hw":1,"hh":0.1,"omega":-8,"angle":0,"style":"spinner"},
  ],
};
